<template>
  <span>
    <el-button type="text" @click="check">查重合并</el-button>
    <el-dialog title="查重与合并" :visible.sync="visible" width="720px" append-to-body>
      <el-alert title="仅展示你有权限查看的疑似重复记录。合并后保留目标资料，跟进和关联单据迁入目标，原记录归档留存。公海资源需先领取。" type="info" :closable="false" />
      <el-table :data="rows" v-loading="loading" border style="margin-top:16px" empty-text="当前范围未发现重复记录；若保存仍提示重复，请联系主管核实">
        <el-table-column prop="name" label="名称" min-width="150" />
        <el-table-column prop="phone" label="电话" min-width="120" />
        <el-table-column v-if="kind === 'lead'" prop="company_name" label="公司" min-width="140" />
        <el-table-column label="归属" width="80"><template slot-scope="{ row }">{{ row.in_pool ? '公海' : '私海' }}</template></el-table-column>
        <el-table-column label="操作" width="120"><template slot-scope="{ row }"><el-button type="text" :disabled="!record.id || !!row.in_pool || !!record.inPool || merging" @click="mergeInto(row)">合并到此记录</el-button></template></el-table-column>
      </el-table>
      <div slot="footer"><el-button @click="visible=false">关闭</el-button></div>
    </el-dialog>
  </span>
</template>
<script>
import { crm } from '../api/crm'
export default {
  name: 'CrmDuplicates',
  props: { kind: { type: String, required: true }, record: { type: Object, required: true } },
  data() { return { visible: false, loading: false, rows: [], merging: false } },
  methods: {
    async check() {
      this.visible = true
      this.rows = []
      this.loading = true
      try {
        const res = await crm.duplicates(this.kind.toUpperCase(), { id: this.record.id, phone: this.record.phone, company: this.kind === 'lead' ? this.record.companyName : this.record.name })
        this.rows = res.data || []
      } finally { this.loading = false }
    },
    async mergeInto(row) {
      try { await this.$confirm(`将当前记录 #${this.record.id} 合并至「${row.name}」？目标资料优先，原记录归档。`, '确认合并', { type: 'warning' }) } catch (_) { return }
      this.merging = true
      try {
        await crm.merge(this.kind.toUpperCase(), this.record.id, row.id)
        this.visible = false
        this.$message.success('已合并，原记录已归档')
        this.$emit('merged', row.id)
      } finally { this.merging = false }
    }
  }
}
</script>
